import React, { useEffect } from 'react';
import { useFestivalWorkspaceStore } from '@/stores/festival-workspace-store';
import {
  HOME_TABS,
  useHomeDashboardStore,
} from '@/stores/home-dashboard-store';
import { API_BASE_URL } from '../../api-base-url';
import { Festivals } from '../festivals';
import { Performers } from '../performers';
import { SectionNavbar } from '../section-navbar';
import { Vendors } from '../vendors';

export default function Home() {
  const clearFestivalWorkspace = useFestivalWorkspaceStore(
    (s) => s.clearFestivalWorkspace,
  );
  const activeTab = useHomeDashboardStore((s) => s.activeTab);
  const setActiveTab = useHomeDashboardStore((s) => s.setActiveTab);

  useEffect(() => {
    clearFestivalWorkspace();
  }, [clearFestivalWorkspace]);

  /** Labels match BeThere `event-mgt.html` tab nav: My Events / My Vendors / My Performers */
  const sections = [
    {
      id: HOME_TABS.events,
      title: 'My Events',
      component: <Festivals />,
    },
    {
      id: HOME_TABS.vendors,
      title: 'My Vendors',
      component: <Vendors />,
    },
    {
      id: HOME_TABS.performers,
      title: 'My Performers',
      component: <Performers />,
    },
  ];

  const selectedIndex = Math.max(
    0,
    sections.findIndex((section) => section.id === activeTab),
  );

  const showBuildInfo = import.meta.env.MODE === 'development';
  const deployDate = import.meta.env.VITE_DEPLOY_DATE;

  return (
    <div className="flex min-h-full flex-col">
      <SectionNavbar
        navItems={sections}
        selectedIndex={selectedIndex}
        onSelectionChanged={(index) => setActiveTab(sections[index].id)}
      />
      {showBuildInfo && (deployDate || API_BASE_URL) && (
        <div className="mt-auto px-4 py-8 text-center text-sm text-[var(--muted-foreground)] md:px-6">
          {deployDate && <div>Deploy date: {deployDate}</div>}
          {API_BASE_URL && <div>API URL: {API_BASE_URL}</div>}
        </div>
      )}
    </div>
  );
}
